module.exports = __webpack_public_path__ + "packs/media/images/covid/covid_1-33689b37bede0695283bf62eda338832.png";